const normalizeStored = (raw) => {
  if (raw === "zh" || raw === "en") return raw;
  return null;
};

const resolveFromNavigator = () => {
  if (typeof navigator === "undefined") return "en";
  const tags =
    navigator.languages && navigator.languages.length
      ? navigator.languages
      : [navigator.language];
  for (const tag of tags) {
    const lower = (tag || "").toLowerCase();
    if (lower.startsWith("zh")) return "zh";
    if (lower.startsWith("en")) return "en";
  }
  return "en";
};

/**
 * 初始界面语言：localStorage.lang → 浏览器语言 → en
 */
export function resolveInitialAppLocale() {
  const fromLang = normalizeStored(localStorage.getItem("lang"));
  if (fromLang) return fromLang;

  return resolveFromNavigator();
}
